import { HOW_IT_WORKS, SIGNUP_URL } from '../data/mock';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

export default function HowItWorks() {
  return (
    <section className="section section-fade">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <p className="chip mb-4">How ACTIWA Works</p>
          <h2 className="text-3xl md:text-5xl font-extrabold tracking-tight text-slate-900">
            From Lead to Loyal Customer
          </h2>
          <p className="mt-4 text-slate-600">
            Five simple steps to transform your WhatsApp marketing and start engaging customers at scale.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-5 gap-5">
          {HOW_IT_WORKS.map((s, i) => (
            <div
              key={s.step}
              className="relative bg-white border border-slate-200 rounded-2xl p-6 card-lift"
            >
              <div className="flex items-center gap-3">
                <span className="text-xs font-bold text-emerald-700 bg-emerald-50 border border-emerald-100 px-2.5 py-1 rounded-full">
                  {s.step}
                </span>
                {i < HOW_IT_WORKS.length - 1 && (
                  <div className="hidden lg:block absolute right-[-14px] top-1/2 -translate-y-1/2 w-7 h-0.5 bg-emerald-200 z-0" />
                )}
              </div>
              <h3 className="mt-4 text-lg font-bold text-slate-900">{s.title}</h3>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">{s.desc}</p>
              <div className="mt-4 flex flex-wrap gap-1.5">
                {s.tags.map((t) => (
                  <span key={t} className="text-[11px] font-medium px-2 py-1 rounded-md bg-slate-100 text-slate-700">
                    {t}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 flex justify-center">
          <a href={SIGNUP_URL} target="_blank" rel="noreferrer">
            <Button size="lg" className="bg-brand-purple hover:bg-brand-purple-dark text-white rounded-full px-7 h-12">
              Start Free Trial <ArrowRight size={18} className="ml-2" />
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
}
